<form
  [formGroup]="form"
  (ngSubmit)="onSubmitForm()">
  @if (isUpdateLoading() || isSaveLoading()) {
    <bn-web-ui-loading />
  }
  <bn-web-ui-card
    class="mb-2"
    [isFullWidth]="true">
    <div class="row">
      <div class="col-md-6 col-xl-6 col-12">
        <bn-web-ui-input
          borderRadius="lg"
          formControlName="Name"
          id="app-shield-rate-limit-rule-name"
          itemStyle="primary"
          label="Name"
          placeholder="Enter Rate Limit Rule name"
          size="md"
          [hideErrorMessages]="true"
          (paste)="onPaste($event, 'Name')" />

        <!-- Name custom error -->
        @let nameControl = form.get('Name');
        @if (nameControl?.invalid && nameControl?.touched && nameControl?.errors) {
          <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
            Please enter a name for your Rate Limit Rule. It can include letters, numbers and spaces only.
          </bn-web-ui-formcontrol-errors>
        }
      </div>

      <div class="col-md-6 col-xl-6 col-12">
        <bn-web-ui-input
          borderRadius="lg"
          formControlName="Description"
          id="app-shield-rate-limit-rule-description"
          itemStyle="primary"
          label="Description"
          placeholder="Enter Rate Limit Rule description"
          size="md"
          [hideErrorMessages]="true"
          (paste)="onPaste($event, 'Description')" />

        <!-- Description custom error  -->
        @let descriptionControl = form.get('Description');
        @if (descriptionControl?.invalid && descriptionControl?.touched && descriptionControl?.errors) {
          <bn-web-ui-formcontrol-errors [withCustomPlaceHolder]="true">
            Please enter a description for your Rate Limit Rule. It can include letters, numbers and spaces only.
          </bn-web-ui-formcontrol-errors>
        }
      </div>
    </div>
  </bn-web-ui-card>
  <bn-web-ui-card
    class="mb-2"
    heading="Request Matching">
    <bn-web-ui-card
      backgroundColor="dark-1"
      formArrayName="requestMatchers"
      [learnMore]="{
        href: 'https://docs.bunny.net/docs/shield-creating-a-ratelimit-rule',
        options: {
          topValue: 'var(--bn-spacer-3)',
          rightValue: 'var(--bn-spacer-3)',
        },
      }"
      [noPadding]="true">
      <!-- requestMatchers form  -->
      @for (matcher of requestMatchers.controls; track matcher; let isFirst = $first; let isLast = $last) {
        <div
          class="px-4 pt-2 pb-0"
          [formGroupName]="$index"
          [ngClass]="{ 'pt-4': isFirst, 'pb-4': isLast }">
          @if (isFirst) {
            <p class="base-2">Please use the below fields to build a request criteria to match rate limiting against.</p>
          }
          <div class="d-flex flex-row gap-1 align-items-start">
            <div class="flex-fill">
              <bn-web-ui-card
                data-e2e="RateLimitRulesCondition"
                [noPadding]="true">
                <div
                  class="p-4 pb-2"
                  [ngClass]="{ 'pt-4': isFirst, 'pb-4': isLast }">
                  <div
                    class="row"
                    style="--bs-gutter-y: var(--bn-spacer-3)">
                    <div class="col-12 col-xl-6">
                      <bn-web-ui-select
                        formControlName="ConditionsVariable"
                        id="app-shield-rate-limit-variable-type"
                        label="Variable"
                        size="md"
                        [items]="wafRuleVariableTypes | mapWafEnumToSelectItems: isPremium"
                        [options]="{
                          isSearchable: true,
                          placeholder: 'Select Variable',
                        }" />
                    </div>
                    <div class="col-12 col-xl-6">
                      <bn-web-ui-select
                        formControlName="ConditionsOperator"
                        id="app-shield-rate-limit-operator-type"
                        label="Operator"
                        size="md"
                        [items]="wafRuleOperatorType | mapWafEnumToSelectItems: isPremium"
                        [options]="{
                          isSearchable: true,
                          placeholder: 'Select Operator',
                        }" />
                    </div>
                    <div class="col-12 col-xl-6">
                      @if (matcher.get('VariableValue')?.disabled === false) {
                        <bn-web-ui-input
                          formControlName="VariableValue"
                          label="Variable Value"
                          placeholder="Enter value"
                          size="md" />
                      }
                    </div>
                    <div class="col-12 col-xl-6">
                      @if (matcher.get('OperatorValue')?.disabled === false) {
                        <bn-web-ui-input
                          formControlName="OperatorValue"
                          label="Operator Value"
                          placeholder="Enter value"
                          size="md" />
                      }
                    </div>
                  </div>
                </div>
              </bn-web-ui-card>
            </div>
            @if (requestMatchers.controls.length > 1) {
              <div class="flex-shrink-1 ms-1">
                <!-- Remove button -->
                <bn-web-ui-button
                  aria-label="Remove condition"
                  class="bn-button--circle bn-button--remove"
                  itemStyle="stroke"
                  size="xs"
                  title="Remove condition"
                  type="button"
                  (click)="onRemoveMatcher($index)">
                  <fa-icon icon="xmark" />
                </bn-web-ui-button>
              </div>
            }
          </div>
        </div>
      }
      <!-- ADD MATCHER -->
      <div class="ms-1 pb-2">
        <button
          bn-web-ui-button
          itemStyle="link"
          type="button"
          [disabled]="!requestMatchers.valid"
          (click)="onAddMatcher()">
          + Add Condition
        </button>
      </div>
    </bn-web-ui-card>
    <!-- Transformer -->
    <div class="py-4">
      <bn-web-ui-select
        formControlName="Transformations"
        label="Transformations"
        size="md"
        [items]="wafRuleTransformationType | mapWafEnumToSelectItems: isPremium"
        [options]="options" />
    </div>
  </bn-web-ui-card>
  <bn-web-ui-card
    class="mb-2"
    heading="Rate exceeding">
    <bn-web-ui-card
      backgroundColor="dark-1"
      [noPadding]="true">
      <div class="p-4">
        <p>Please use the below fields to set limits on the above matching requests.</p>
        <bn-web-ui-card [noPadding]="true">
          <div class="p-4">
            <div
              class="row"
              style="--bs-gutter-y: var(--bn-spacer-3)">
              <div class="col-12 col-xl-4">
                <bn-web-ui-select
                  formControlName="CounterKeyType"
                  label="Counter Key"
                  size="md"
                  [items]="wafRatelimitCounterKeyType | mapWafEnumToSelectItems: isPremium"
                  [options]="{
                    isSearchable: true,
                    placeholder: 'Counter Key',
                  }" />
              </div>
              <div class="col-12 col-xl-4">
                <bn-web-ui-input
                  formControlName="RateExceedingRequests"
                  label="Requests"
                  placeholder="1000"
                  size="md"
                  type="number" />
              </div>
              <div class="col-12 col-xl-4">
                <bn-web-ui-select
                  formControlName="RateExceedingTimeframe"
                  label="Timeframe"
                  size="md"
                  [items]="wafRateLimitTimeframeType | mapWafEnumToSelectItems: isPremium"
                  [options]="{
                    isSearchable: true,
                    placeholder: 'Select Timeframe',
                  }" />
              </div>
            </div>
          </div>
        </bn-web-ui-card>
      </div>
    </bn-web-ui-card>
  </bn-web-ui-card>

  <bn-web-ui-card
    class="mb-2"
    heading="Response action">
    <bn-web-ui-card
      backgroundColor="dark-1"
      [noPadding]="true">
      <div class="p-4">
        <p>Please use the below fields to set the outcome of a rate limited request.</p>
        <bn-web-ui-card [noPadding]="true">
          <div class="p-4">
            <div
              class="row"
              style="--bs-gutter-y: var(--bn-spacer-3)">
              <div class="col-12 col-xl-6">
                <bn-web-ui-select
                  formControlName="ResponseAction"
                  label="Action"
                  size="md"
                  [items]="wafRuleActionType | mapWafEnumToSelectItems: isPremium"
                  [options]="{
                    isSearchable: true,
                    placeholder: 'Select Action',
                  }" />
              </div>
              <div class="col-12 col-xl-6">
                <bn-web-ui-select
                  formControlName="ResponseActionTimeframe"
                  label="Timeframe"
                  size="md"
                  [items]="wafRatelimitBlockType | mapWafEnumToSelectItems: isPremium"
                  [options]="{
                    isSearchable: true,
                    placeholder: 'Select Timeframe',
                  }" />
              </div>
            </div>
          </div>
        </bn-web-ui-card>
        <!--bn-web-ui-card
        class="mb-2"
        heading="Summary">
        <p>
          Below is a human readable version of the above rule, please ensure it’s correct before
          creating the rate limit.
        </p>
        <bn-web-ui-card
          backgroundColor="dark-1"
          [noPadding]="true">
          <div class="p-4">
            <div class="mb-4 d-flex flex-wrap gap-1">
              <bn-web-ui-bordered-box size="lg">IF</bn-web-ui-bordered-box>
              <bn-web-ui-bordered-box size="lg">Condition matches</bn-web-ui-bordered-box>
              <bn-web-ui-bordered-box
                class="text-uppercase"
                size="lg"
                context="info"
                >User agent</bn-web-ui-bordered-box
                >
                <bn-web-ui-bordered-box size="lg"
                  >Super Bad User Agent, It’s the Worst”</bn-web-ui-bordered-box
                  >
                  <bn-web-ui-bordered-box size="lg"
                    ><fa-icon icon="arrow-right"></fa-icon
                  ></bn-web-ui-bordered-box>
                  <bn-web-ui-bordered-box
                    class="text-uppercase"
                    size="lg"
                    context="danger"
                    >Block</bn-web-ui-bordered-box
                    >
                  </div>
                  <div class="text-400-regular text-bunny-dark">
                    <p>
                      Any request with the Cookie Name equalling “my_custom_cookie_i_want_to_track_and_limit”
                      with a rate exceeding 16.6 requests per second (1000 requests per 60 seconds), will be
                      served a JS Challenge for a 60 second duration.
                    </p>
                  </div>
                </div>
              </bn-web-ui-card>
            </bn-web-ui-card-->
      </div>
    </bn-web-ui-card>
  </bn-web-ui-card>
  <div
    bnIsElementStuck
    class="mt-2"
    [stickyEnabled]="form.dirty">
    <div class="bn-sticky-save-button__wrapper d-flex align-items-center justify-content-between">
      <button
        bn-web-ui-button
        size="xl"
        type="submit"
        [loading]="isAddFinished() || isUpdateFinished()">
        {{ rateLimitId ? 'Update' : 'Save' }}
      </button>
      <button
        bn-web-ui-button
        class="ms-3"
        itemStyle="stroke"
        size="xl"
        type="button"
        (click)="onCancelClick()">
        Cancel
      </button>
      @if (form.dirty) {
        <span class="bn-container-list__save-row__unsaved-title"
          ><fa-icon
            class="ms-4"
            icon="triangle-exclamation" />
          You have unsaved changes.</span
        >
      }
    </div>
  </div>
</form>
